/**
 * @generated SignedSource<<0ad5313cf181c468eacb02c69489c021>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppChrome$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GlobalSideNavigation" | "GlobalTopNavigation">;
  readonly " $fragmentType": "AppChrome";
};
export type AppChrome$key = {
  readonly " $data"?: AppChrome$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppChrome">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AppChrome",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "GlobalTopNavigation"
    },
    {
      "kind": "FragmentSpread",
      "name": "GlobalSideNavigation"
    }
  ],
  "type": "Query"
};

(node as any).hash = "2109341738cb14d5473a35fae1246408";

export default node;
